import { html, unsafeCSS } from 'lit';
import { customElement } from 'lit/decorators.js';
import { ref } from 'lit/directives/ref.js';
import { repeat } from 'lit/directives/repeat.js';
import { UIModalServiceModal } from '../../../app/package/base/service/modals/modal-service';
import { ProductSwitcherIconName, type ProductSwitcherItemProp } from '../../../app/package/base/types';
import { I18n } from '../../base/package/services/package/i18n/i18n.de';
import '../ui-input/ui-dropdown';
import { classMap } from 'lit/directives/class-map.js';
import styles from './ui-product-switcher.css?inline';
import '../ui-product-switcher-item/ui-product-switcher-item';

const CName = 'ui-product-switcher';

@customElement(CName)
export class UIProductSwitcher extends UIModalServiceModal {
  static readonly styles = unsafeCSS(styles);

  private _closedByItemClick = false;

  constructor(private readonly _isLoggedIn: boolean) {
    super();
  }

  public close() {
    this._closedByItemClick = true;
    this._modalRef.value?.close();
  }

  connectedCallback(): void {
    super.connectedCallback();
    this._trackEvent('shown');
  }

  disconnectedCallback(): void {
    super.disconnectedCallback();
    if (!this._closedByItemClick) {
      this._trackEvent('closed');
    }
  }

  render() {
    const productSwitcherItems: ProductSwitcherItemProp[] = window.$app.appConfig.productSwitcherItems;
    const productItemClasses = classMap({
      'product-item': true,
      'product-item--no-bottom-border': productSwitcherItems.length === 1,
    });

    return html`
      <ui-modal ${ref(this._modalRef)}>
        <div slot="title">${window.$app.$t.get(I18n.productSwitcher.moreFromTipico)}</div>
        <div slot="main">
          ${repeat(
            productSwitcherItems.filter((item) =>
              window.$app.device.isNativeApp ? item.icon !== ProductSwitcherIconName.TIPICO_GAMES : item,
            ),
            (productSwitcherItem: ProductSwitcherItemProp) => productSwitcherItem.text,
            (productSwitcherItem: ProductSwitcherItemProp) => html`
              <ui-product-switcher-item
                class=${productItemClasses}
                .item=${productSwitcherItem}
                .isLoggedIn=${this._isLoggedIn}
                @click=${this.close}
              ></ui-product-switcher-item>
            `,
          )}
        </div>
      </ui-modal>
    `;
  }

  private _trackEvent(action: 'shown' | 'closed' | 'goToGames' | 'confirm' | 'yes_i_am') {
    window.$app.track.productSwitcher({
      event: window.$app.appSettings.isSHCasino ? 'xsellGamesSH' : 'productSwitcher',
      eventAction: this._isLoggedIn ? 'logged_in_modal' : 'logged_out_modal',
      status: this._isLoggedIn ? 'loggedIn' : 'loggedOut',
      action,
    });
  }
}

declare global {
  interface HTMLElementTagNameMap {
    [CName]: UIProductSwitcher;
  }
}
